// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"7f4110dc","508":"460f4188","629":"d4993e0e","776":"832aaf19"}[chunkId] + ".chunk.js";
};